<template>
  <b-form>
    <b-form-row>
      <b-form-group class="col-sm-12">
        <label for="componente">Componente  <span style="color: red">(*)</span></label>
        <b-form-input
          type="text"
          name="componente"
          v-model="selectedValorExpo.componente"
          required
        >
        </b-form-input>
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- TWA ACGIH -->
      <BInputUm
        bv_class="col-sm-6"
        parentState="selectedValorExpo"
        input_text="TWA (ACGIH)"
        v_model_range="twa_acgih_rango"
        v_model="twa_acgih"
        v_model_up_to="twa_acgih_hasta"
        v_model_um="id_um_twa_acgih"
        um_type="TCC-af"
        :values="selectedValorExpo"
      />
      <b-form-group class="col-sm-6">
        <label for="twa_acgih">Observación TWA (ACGIH)</label>
        <b-form-textarea
          name="twa_acgih"
          v-model="selectedValorExpo.twa_acgih_observacion"
        >
        </b-form-textarea>
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- STEL ACGIH -->
      <BInputUm
        bv_class="col-sm-6"
        parentState="selectedValorExpo"
        input_text="STEL (ACGIH)"
        v_model_range="stel_acgih_rango"
        v_model="stel_acgih"
        v_model_up_to="stel_acgih_hasta"
        v_model_um="id_um_stel_acgih"
        um_type="TCC-af"
        :values="selectedValorExpo"
      />
      <b-form-group class="col-sm-6">
        <label for="stel_acgih">Observación STEL (ACGIH)</label>
        <b-form-textarea
          name="stel_acgih"
          v-model="selectedValorExpo.stel_acgih_observacion"
        >
        </b-form-textarea>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>

<script>
import {mapState} from "vuex";
import BInputUm from "../../componentes/BInputUm";

export default {
  name: "ModalFormValoresExposicion",
  components: {
    BInputUm
  },
  computed: {
    ...mapState('fds_productos',[
      'selectedValorExpo'
    ]),
  }
}
</script>

<style scoped>

</style>
